
import _ from 'lodash'
import {getMaxId} from '@/utils/paperUtil'

function updatePaperList(data) {
    // let fromDataJSON = localStorage.getItem('questionData');
    // if (fromDataJSON){
    //     let fromData_ = JSON.parse(fromDataJSON);
    //     fromData_.paperList = data
    //     localStorage.setItem('questionData', JSON.stringify(fromData_));
    // }
}

export default {
    namespaced: true,
    state: {
        paperList: [],
        id: 1,
        currentCardIndex: null
    },
    getters: {
        treePaperList: (state) => (treeId) => {
            return state.paperList.filter(item => item.treeId === treeId)
        },
        currentPaper(state) {
            const currentCardId = state.currentCardIndex
            let paper
            if (currentCardId) {
                paper = state.paperList.find(item => item.id === currentCardId)
            }
            return paper ? paper : null
        },
        paperById: (state) => (id) => {
            return state.paperList.find(item => item.id === id)
        },
        paperList(state) {
            return _.sortBy(state.paperList,
                [o => o.paperNum.split('-')[0],o => Number(o.paperNum.split('-')[1])])
        }
    },
    mutations: {
        init(state, { data, id }) {
            state.paperList = data
            state.id = id
        },
        setCurrentCardIndex(state, index) {
            state.currentCardIndex = index
        },
        add(state, data) {
            if (data) {
                data.id = state.id
                state.paperList.push(data)
                state.id++
                updatePaperList(state.paperList)
            }
        },
        update(state, {paper, id}) {
            if (paper) {
                const index = state.paperList.findIndex((item) => item.id === id)
                if (index >= 0) {
                    state.paperList.splice(index, 1, paper)
                }
                updatePaperList(state.paperList)
            }
        },
        remove(state, id) {
            const index = state.paperList.findIndex((item) => item.id === id)
            if (index >= 0) {
                state.paperList.splice(index, 1)
                updatePaperList(state.paperList)
            }
        }
    },
    actions: {
        init({ state, rootState, commit,  dispatch,   getters, rootGetters }, paperList) {
            // 初始化
            console.log(paperList)
            if (paperList && paperList.length) {
                let maxId = getMaxId(paperList)
                const id = ++maxId
                commit('init', {
                    data: paperList,
                    id: id
                })
            }
        },
        add({ state, rootState, commit,  dispatch,   getters, rootGetters }) {

        },
        remove({ state, rootState, commit,  dispatch,   getters, rootGetters }, id) {
            // 删除题目
            commit('remove', id)
            // 删除逻辑控制关联数据
            commit('question/logic/removeByPaperId', id, { root: true })
            // 删除分类中关联数据
            commit('question/allConfig/removePaperId', id, { root: true })
            // 删除分值上限中关联数据
            commit('question/paperGroupScore/removePaperId', id, { root: true })
        },
        removeByTreeId({ state, rootState, commit,  dispatch,   getters, rootGetters }, treeId) {
            const paperList = state.paperList.filter(item => item.treeId === treeId)
            paperList.forEach((item) => {
                dispatch('remove', item.id)
            })
        }
    }
}
